import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lock, Crown } from 'lucide-react';
import { Button } from './ui/button';

const PremiumLock = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={`absolute inset-0 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center rounded-lg z-10 ${className}`}>
      <Lock className="w-8 h-8 text-amber mb-2" />
      <p className="text-sm text-zinc-400 mb-3">{t('common.locked')}</p>
      <Link to="/premium">
        <Button size="sm" className="bg-gradient-to-r from-amber to-orange-500 text-black font-semibold">
          <Crown className="w-4 h-4 mr-1" />
          {t('common.unlock')}
        </Button>
      </Link>
    </div>
  );
};

export default PremiumLock;
